import { createElement } from 'react'
import { AutoCompleteOption } from '../../../../../../../../components/custom-form-controls/auto-complete'
import MaterialWidthOptionLabel from '../../../../../../../../components/materials/material-width-option-label'
import Stock from '../../../../../../../../types/api/stock'
import calculateStockAmount from '../../../../../../../../helpers/entities/stock/calculate-stock-amount'

export const buildMaterialWidthOptions = (stocks: Stock[] = []): AutoCompleteOption[] => {
    return [...stocks]
        .sort((a, b) => a.material.width - b.material.width)
        .map(item => {
            const width = item.material.width
            const stock = calculateStockAmount(item)

            return {
                label: createElement(MaterialWidthOptionLabel, { width, stock }),
                value: width,
                key: item.material.documentId,
                stock,
            }
        })
}
